module.exports = __webpack_public_path__ + "img/facebook_tag.87ca2602.jpg";